var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFineChemicals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    rx: 40,
    fill: "#8668ad"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.64,217.41a26.74,26.74,0,0,1-5.51-16.22V144.71a6.47,6.47,0,0,1,6.47-6.47,4,4,0,1,0,0-8,14.48,14.48,0,0,0-14.47,14.47v56.48a34.78,34.78,0,0,0,7.17,21.1l33.17,43.14a19,19,0,0,1-15,30.51H124.32a19,19,0,0,1-15-30.51l33.17-43.14a34.84,34.84,0,0,0,7.17-21.1V144.71a14.48,14.48,0,0,0-14.47-14.47,4,4,0,1,0,0,8,6.47,6.47,0,0,1,6.47,6.47v56.48a26.78,26.78,0,0,1-5.51,16.22L103,260.55a27,27,0,0,0,21.37,43.39h83.12a27,27,0,0,0,21.37-43.39Zm90.49-36.09a4,4,0,0,0-5.47-1.46L263.17,190l-15.49-9V163.12L265.17,153a4,4,0,1,0-4-6.92l-17.49,10.1-17.5-10.1a4,4,0,0,0-4,0l-19.49,11.25a4,4,0,0,0-2,3.46v22.51a4,4,0,0,0,2,3.47L222.18,198a4,4,0,0,0,2,.54,3.93,3.93,0,0,0,2-.54l17.5-10.1,15.49,8.95v20.2a4,4,0,0,0,8,0v-20.2l17.49-10.1A4,4,0,0,0,286.13,181.32ZM239.68,181l-15.5,9-15.49-9V163.13l15.49-8.95,15.5,8.95Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.88,142.87a13.2,13.2,0,1,0-13.2-13.2A13.21,13.21,0,0,0,165.88,142.87Zm0-18.4a5.2,5.2,0,1,1-5.2,5.2A5.2,5.2,0,0,1,165.88,124.47Zm30-44.41a20.31,20.31,0,1,0,20.32,20.31A20.34,20.34,0,0,0,195.83,80.06Zm0,32.62a12.31,12.31,0,1,1,12.32-12.31A12.33,12.33,0,0,1,195.83,112.68ZM183.78,228.16H146.59a4,4,0,0,0,0,8h37.19a4,4,0,0,0,0-8Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineChemicals);
export default __webpack_public_path__ + "static/media/fine-chemicals.bfde8d52b889eb7cd467e79b4e2dbcc3.svg";
export { ForwardRef as ReactComponent };